import React from "react";

const HeroPricing = () => {
  return (
    <div className="w-full bg-bgPricing bg-primary-grey rounded-lg-5 h-96 max-md:h-44 flex flex-col justify-center items-center space-y-28 text-black">
      <h1 className="text-6xl font-extrabold max-lg:font-lg max-lg:text-4xl text-center leading-[150px] max-md:text-xl max-lg:-mt-24">
        Grow faster with Wolburg
        <p className=" mt-15 text-sm">Pricing Packs</p>
      </h1>
    </div>
  );
};

export default HeroPricing;
